var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { action, observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { addDisplayName } from "../Infra/display-name";
import { StyledMenu, HXMenuTitle, HXMenuFooter } from "./HXMenu.styles";
export class HXMenuController {
    constructor(onOpen, onClose) {
        this.anchorEl = null;
        this.onOpen = onOpen;
        this.onClose = onClose;
    }
    openMenu(anchorAt) {
        var _a;
        this.anchorEl = anchorAt;
        (_a = this.onOpen) === null || _a === void 0 ? void 0 : _a.call(this);
    }
    closeMenu() {
        var _a;
        this.anchorEl = null;
        (_a = this.onClose) === null || _a === void 0 ? void 0 : _a.call(this);
    }
}
__decorate([
    observable
], HXMenuController.prototype, "anchorEl", void 0);
__decorate([
    action
], HXMenuController.prototype, "openMenu", null);
__decorate([
    action
], HXMenuController.prototype, "closeMenu", null);
export const HXMenu = observer((props) => {
    var _a;
    const transformOrigin = props.position === "right"
        ? { horizontal: "left", vertical: "top" }
        : props.position === "above"
            ? { horizontal: "center", vertical: "bottom" }
            : { horizontal: "right", vertical: -1 * ((_a = props.verticalMenuOffset) !== null && _a !== void 0 ? _a : 0) };
    const anchorOrigin = props.position === "right"
        ? { horizontal: "right", vertical: "top" }
        : props.position === "above"
            ? { horizontal: "center", vertical: -8 }
            : { horizontal: "right", vertical: "bottom" };
    return (_jsxs(StyledMenu, { anchorEl: props.controller.anchorEl, id: "account-menu", open: !!props.controller.anchorEl, onClose: () => props.controller.closeMenu(), onClick: () => props.controller.closeMenu(), transformOrigin: transformOrigin, anchorOrigin: anchorOrigin, children: [props.title && _jsx(HXMenuTitle, { children: props.title }), props.children, props.footer && _jsx(HXMenuFooter, { children: props.footer })] }));
});
addDisplayName(HXMenu, "HXMenu");
